import React from 'react';

import { UiTypography } from '@/components/ui/Typography/index.ts';
import { PAYWALL_TIMER_MINUTES } from '@/constants.ts';

import { TimerTypography } from '../TimerTypography';

import {
  Card,
  DiscountText,
  Divider,
  Footer,
  Header,
  PromoCodeContainer,
  PromoCodeIcon,
  PromoCodeText,
} from './PromoCode.styles.ts';
import { formatPromoCodeText } from './utils';

interface PromoCodeProps {
  text?: string;
}

export const PromoCode: React.FC<PromoCodeProps> = ({ text = '' }) => {
  const formattedText = formatPromoCodeText(text);

  return (
    <Card>
      <Header>
        <UiTypography variant={'title-medium'}>
          Discount reserved for:
        </UiTypography>
        <TimerTypography timeToExpire={PAYWALL_TIMER_MINUTES * 1000 * 60} />
      </Header>
      <Divider />
      <Footer>
        <PromoCodeContainer>
          <PromoCodeIcon />
          <PromoCodeText>{formattedText}</PromoCodeText>
        </PromoCodeContainer>
        <DiscountText>50% OFF</DiscountText>
      </Footer>
    </Card>
  );
};
